import { ComponentRoute } from '@/classes'

const CreditorAgingReportRoutes = {
  CreditorAgingReportView: new ComponentRoute('/apagingreports', 'CreditorAgingReportView')
}

export default CreditorAgingReportRoutes
